import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "truncated-text"
}
const _hoisted_3 = { key: 1 }

import { computed } from "vue"

interface Props {
  text?: string
  length?: number
  tooltipMaxWidth?: number
  tooltipPlacement?: "top" | "bottom" | "left" | "right"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TooltipTooLong',
  props: {
    text: { default: "" },
    length: { default: 16 },
    tooltipMaxWidth: { default: 350 },
    tooltipPlacement: { default: "top" }
  },
  setup(__props: any) {

const props = __props

const isTruncated = computed(() => props.text.length >= props.length)

const truncatedText = computed(() =>
  props.text.substring(0, props.length) + (isTruncated.value ? "..." : "")
)

return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_ctx.text)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        (isTruncated.value)
          ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createTextVNode(_toDisplayString(truncatedText.value), 1)
            ])), [
              [_directive_tippy, {
        content: _ctx.text,
        maxWidth: _ctx.tooltipMaxWidth,
        placement: _ctx.tooltipPlacement
      }]
            ])
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.text), 1))
      ]))
    : _createCommentVNode("", true)
}
}

})